import { Badge, Box, Button, Card } from "@mui/material";
import React, { useMemo } from "react";
import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";
import {
  ChevronRightOutlined,
  Description,
  PriorityHighOutlined,
} from "@mui/icons-material";
import { blue, blueGrey, grey, yellow } from "@mui/material/colors";

const QuickActionButton = ({
  title,
  icon,
  description = "Example description",
  onClick,
  badgeIcon = <PriorityHighOutlined sx={{ fontSize: "13px" }} />,
  badge = false,
  badgeColor = "error",
}) => {
  const styles = useMemo(() => {
    return {
      // border: "1px solid #e0e0e0",
      flexGrow: 1,
      gap: 2.5,
      // minHeight: "125px",
      padding: "16px",
      display: "flex",
      alignItems: "center",
      // flexDirection: "column",
      cursor: "pointer",
      backgroundColor: "#ffffff",
      // flexBasis: "200px",
      // fontSize: "13px",
      // fontWeight: 600,
      // lineHeight: 1.4,
      // ".MuiButton-icon": {
      //   m: 0,
      //   // color: "#c19c0a",
      //   // color: "#8b7005",//readable
      //   color: "#fbca0b",
      //   // color: "#d0a705ff",
      //   ".MuiSvgIcon-root": {
      //     fontSize: "42px",
      //   },
      // },
      ":hover": {
        backgroundColor: "#fbfdff",
        border: "1px solid #90caf9",
        // backgroundColor: "#fefef6ff",
        // svg: {
        //   stroke: "#030506",
        // },
      },
    };
  }, []);

  const returnContent = (
    <Card sx={{ ...styles }} onClick={onClick}>
      <Flx
        center
        sx={{
          flexShrink: 0,
          width: "58px",
          height: "58px",
          borderRadius: "8px",
          background: blue[50],
          // background: #fef3c7, // yellow
          // background: yellow[50],
          // background: "#fbcb0b0b",
          color: grey[700],
          // color: yellow[900],
          // color: "#fbca0b",
          ".MuiSvgIcon-root": {
            color: blue[700],
            // color: '#062e6f',
            fontSize: "28px",
          },
        }}
      >
        {icon}
      </Flx>
      <Flx gap={"1px"} column sx={{ flexGrow: 1 }}>
        <Txt bold>{title}</Txt>
        <Txt secondary>{description}</Txt>
      </Flx>
      <ChevronRightOutlined className="thin" />
    </Card>
  );

  if (badge) {
    return (
      <Badge
        color={badgeColor}
        overlap="rectangular"
        sx={{
          ".MuiBadge-badge": {
            width: "24px",
            height: "24px",
            borderRadius: "40px",
            right: 6,
            top: 6,
          },
        }}
        badgeContent={badgeIcon}
      >
        {returnContent}
      </Badge>
    );
  }

  return returnContent;
};
// const QuickActionButton = ({ title, icon, disabled, onClick }) => {
//   const styles = useMemo(() => {
//     return {
//       // border: "1px solid #e0e0e0",
//       flexGrow: 1,
//       gap: 0.5,
//       minHeight: "125px",
//       padding: "16px",
//       display: "flex",
//       flexDirection: "column",
//       backgroundColor: "#ffffff",
//       flexBasis: "200px",
//       fontSize: "13px",
//       fontWeight: 600,
//       lineHeight: 1.4,
//       ".MuiButton-icon": {
//         m: 0,
//         // color: "#c19c0a",
//         // color: "#8b7005",//readable
//         color: "#fbca0b",
//         // color: "#d0a705ff",
//         ".MuiSvgIcon-root": {
//           fontSize: "42px",
//         },
//       },
//       ":hover": {
//         backgroundColor: "#f6fbfe",
//         svg: {
//           stroke: "#f6fbfe",
//         },
//       },
//     };
//   }, []);

//   return (
//     <Card sx={{ p: 0 }}>
//       <Button
//         fullWidth
//         // variant="outlined"
//         disabled={disabled}
//         sx={styles}
//         onClick={onClick}
//         startIcon={icon}
//       >
//         {title}
//       </Button>
//     </Card>
//   );
// };

export default QuickActionButton;
